var _circle, _circle2, _g, _rect, _rect2, _g2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_184",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_184)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_184)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 14,
    width: 112,
    height: 92,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 30,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 38,
    width: 43,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 54,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 82,
    width: 32,
    height: 8,
    fill: "#008B6D"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_184)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 64,
    height: 92,
    fill: "#DADCE0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_184",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 14,
    width: 64,
    height: 92
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 64,
    height: 92,
    fill: "#E0F5F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 81.2419C20.8463 81.2419 5.32108 91.9078 5.32108 103.536V106.013C5.32108 108.408 7.26092 110.348 9.65592 110.348H70.3437C72.7387 110.348 74.6786 108.408 74.6786 106.013V103.536C74.6786 91.9078 59.1533 81.2419 39.9998 81.2419Z",
    fill: "#1A1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8375 84.3392C50.8375 88.4508 46.5026 93.0088 40.0004 93.0088C33.4981 93.0088 29.1633 88.4508 29.1633 84.3392C29.1633 78.6237 29.1633 69.0913 29.1633 69.0913H50.8375C50.8375 69.0913 50.8375 78.6237 50.8375 84.3392Z",
    fill: "#5B4530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3252 53.9952H58.183V62.6649H59.7067C60.8229 62.6649 61.7744 61.9887 61.9629 61.061L62.7085 57.3699C63.0662 55.6056 61.4514 53.9952 59.3252 53.9952Z",
    fill: "#68523E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6753 53.9952H21.8175V62.6649H20.2938C19.1776 62.6649 18.2261 61.9887 18.0375 61.061L17.2919 57.3699C16.9343 55.6056 18.549 53.9952 20.6753 53.9952Z",
    fill: "#68523E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 28.8531C30.3746 28.8531 20.4933 30.3161 20.4933 51.1234C20.4933 52.788 20.4933 63.8613 20.4933 65.6408C20.4933 73.0685 32.1974 82.1717 40.0001 82.1717C47.8028 82.1717 59.5069 73.0685 59.5069 65.6408C59.5069 63.8613 59.5069 52.7901 59.5069 51.1234C59.5069 30.3161 49.6256 28.8531 40.0001 28.8531Z",
    fill: "#68523E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 27C30.5629 27 29.1627 30.5459 29.1627 30.5459C25.3264 31.1116 18.3256 36.7317 18.3256 43.156C18.3256 46.7409 18.9 49.3895 20.493 58.3279C21.6743 44.1421 25.3676 38.8211 29.1627 38.8211C31.9089 38.8211 34.0893 40.9885 39.9998 40.9885C44.9914 40.9885 46.2312 38.8211 50.837 38.8211C57.3392 38.8211 59.5066 56.0911 59.5066 58.3279C60.8093 51.804 61.6741 46.2879 61.6741 43.156C61.6741 35.7239 53.4574 27 39.9998 27Z",
    fill: "white"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 14,
    width: 11,
    height: 92,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_184",
    x: 65,
    y: 9,
    width: 126,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_184"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_184",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_184",
    x: 1,
    y: 9,
    width: 78,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_184"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_184",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.3fb687a2026a7cd322463ac00a0ecb56.svg";
export { ForwardRef as ReactComponent };